import PropTypes from 'prop-types'
import { forwardRef, memo, useMemo } from 'react'
import { normalizeSizeString } from 'app/util/sizes'
import useFallbackRef from 'lib/react/hooks/useFallbackRef'
import classNames from 'lib/util/classNames'
import lineItemStyles from '../LineItem.module.scss'
import styles from './Title.module.scss'

/**
 * The `Title`
 *
 * @param {object} props - the component props
 * @returns {React.ReactElement} the element
 */
const Title = forwardRef((props, forwardedRef) => {
  const { children, className, size, wrap } = props
  const ref = useFallbackRef(forwardedRef)
  const classNameOutput = useMemo(
    () =>
      classNames([
        className,
        lineItemStyles.title,
        styles.title,
        styles[`size-${normalizeSizeString(size)}`],
        wrap && styles.wrap
      ]),
    [className, size]
  )

  return (
    <h2 ref={ref} className={classNameOutput}>
      {children}
    </h2>
  )
})

// Display name
Title.displayName = 'Title'

/** @type {object} */
Title.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  size: PropTypes.string,
  wrap: PropTypes.bool
}

/** @type {object} */
Title.defaultProps = {
  children: null,
  className: '',
  size: 'standard',
  wrap: false
}

// Memoize
export default memo(Title)
